class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.giftWrapId = this.dataset.giftWrapId;
    this.addButton = this.querySelector("[data-gift-wrap-add]");

    this.addButton?.addEventListener("click", () => this.addGiftWrapToCart());
  }

  getSectionsToRender() {
    const sections = [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
    ];

    if (document.body.classList.contains("template-cart")) {
      const mainCartItemsId =
        document.getElementById("main-cart-items")?.dataset.id;
      const mainCartFooterId =
        document.getElementById("main-cart-footer")?.dataset.id;

      if (mainCartItemsId) {
        sections.push({
          id: "main-cart-items",
          section: mainCartItemsId,
          selector: ".js-contents",
        });
      }
      if (mainCartFooterId) {
        sections.push({
          id: "main-cart-footer",
          section: mainCartFooterId,
          selector: ".js-contents",
        });
      }
    }

    return sections.filter((section) => section.section);
  }

  addGiftWrapToCart() {
    if (!this.giftWrapId || !this.addButton) return;

    this.addButton.classList.add("loading");
    this.addButton.setAttribute("aria-disabled", "true");

    const sections = this.getSectionsToRender().map(
      (section) => section.section,
    );

    const body = JSON.stringify({
      items: [{ id: parseInt(this.giftWrapId, 10), quantity: 1 }],
      attributes: { "gift-wrapping": "yes" },
      sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message || response);
          return;
        }

        if (document.body.classList.contains("template-cart")) {
          this.renderCartSections(response);
          return;
        }

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.addButton.classList.remove("loading");
        this.addButton.removeAttribute("aria-disabled");
      });
  }

  renderCartSections(response) {
    if (!response.sections) return;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element || !response.sections[section.section]) return;

      const elementToReplace =
        element.querySelector(section.selector) || element;
      const html = new DOMParser()
        .parseFromString(response.sections[section.section], "text/html")
        .querySelector(section.selector);

      if (html) elementToReplace.innerHTML = html.innerHTML;
    });

    window.afterMiniCartContentsUpdated?.();
  }
}

customElements.define("gift-wrapping", GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({
          attributes: { "gift-note": event.target.value },
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300),
    );
  }
}

customElements.define("gift-note", GiftNote);
